import React from "react"
import Layout from "../Layout"

const CarouselAnimationView = (props) => (
  <Layout {...props} type="CarouselAnimationView" />
)
export default CarouselAnimationView



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Content/CarouselAnimationView.js